import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";

export const http = axios.create({
  baseURL: "/api/proxy/",
  headers: {
    accept: "application/json",
  },
});

export const publicHttp = axios.create({
  baseURL: "/api/public-proxy/",
  headers: {
    accept: "application/json",
  },
});

export const authHttp = axios.create({
  baseURL: "/api/auth/",
  headers: {
    accept: "application/json",
  },
});


// Rate limiter for chunk uploads to prevent server overload
const chunkUploadRateLimiter = {
  lastRequest: 0,
  minInterval: 1000,
};

// Request interceptor - rate limit chunk uploads
http.interceptors.request.use(async (config) => {
  const url = config.url || "";

  if (url.includes("/record/conversation/chunk")) {
    const now = Date.now();
    const timeSinceLastRequest = now - chunkUploadRateLimiter.lastRequest;
    const waitTime = chunkUploadRateLimiter.minInterval - timeSinceLastRequest;

    if (waitTime > 0) {
      await new Promise((resolve) => setTimeout(resolve, waitTime));
    }

    chunkUploadRateLimiter.lastRequest = Date.now();
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & {
      _retry?: boolean;
    };

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Wait for the proxy to handle token refresh
      await new Promise((resolve) => setTimeout(resolve, 200));

      return http(originalRequest);
    }

    return Promise.reject(error);
  },
);
